import styled from '@marvelapp/styled';
const Semibold = styled.span `
  font-weight: 600;
`;
export default Semibold;
